/** Compact display for metric counts: 3417 -> "3,4k" (fr) / "3.4k" (en).
 *  Cards give a count a few characters of width, and past four digits the exact
 *  figure is noise anyway — nobody reads a view counter to the unit. */

const LOCALES = { fr: 'fr-FR', en: 'en-US', de: 'de-DE', es: 'es-ES', pt: 'pt-BR' };

/** Descending, so the first unit a value clears is the one it is shown in. */
const UNITS = [
    { limit: 1e9, suffix: 'B' },
    { limit: 1e6, suffix: 'M' },
    { limit: 1e3, suffix: 'k' },
];

/** One decimal below ten units (3,4k), none above (34k) — at two integer
 *  digits the decimal costs a character and says nothing. */
const DECIMAL_BELOW = 10;

/** Where the no-decimal rounding of a scaled value tips into the next unit:
 *  999_500 would read "1000k", which the unit above says as "1M". */
const UNIT_OVERFLOW = 999.5;

function localized(value, lang, digits) {
    return value.toLocaleString(LOCALES[lang] || LOCALES.en, {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
    });
}

export function formatCount(value, lang) {
    const n = Number(value);
    if (!Number.isFinite(n)) return '0';

    const abs = Math.abs(n);
    let idx = UNITS.findIndex(u => abs >= u.limit);
    if (idx === -1) return localized(Math.trunc(n), lang, 0);
    if (idx > 0 && abs / UNITS[idx].limit >= UNIT_OVERFLOW) idx -= 1;

    const { limit, suffix } = UNITS[idx];
    const scaled = n / limit;
    const digits = Math.abs(scaled) < DECIMAL_BELOW ? 1 : 0;
    return `${localized(scaled, lang, digits)}${suffix}`;
}
